import { Button, withTranslate } from "react-admin";

import ContentCreate from "@material-ui/icons/Create";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import { linkToRecord } from "ra-core";
import shouldUpdate from "recompose/shouldUpdate";

// useful to prevent click bubbling in a datagrid with rowClick
const stopPropagation = (e) => {
  e.stopPropagation();
};

const EditButton = ({
  basePath = "",
  label = "ra.action.edit",
  record = {},
  icon = <ContentCreate />,
  location,
  translate,
  ...rest
}) => {
  const ModeOpenTabsOn = localStorage.getItem("ModeOpenTabsOn") === "true";

  const handleClick = (e) => {
    if (!ModeOpenTabsOn) {
      return;
    }

    e.preventDefault();

    const id = record.id.toString();
    let openTabsRaw = localStorage.getItem("openEditTabs");
    let openTabs;

    try {
      openTabs = openTabsRaw ? JSON.parse(openTabsRaw) : {};
    } catch {
      openTabs = {};
    }

    if (!Array.isArray(openTabs.location)) {
      openTabs.location = [];
    }

    if (openTabs.location.includes(id)) {
      // alert("Gia aperta");
      alert(
        translate("resource.open.tabs.message.block", {
          resource: "location",
          id: id,
        })
      );
      return; // blocca apertura nuova tab
    }

    openTabs.location.push(id);
    localStorage.setItem("openEditTabs", JSON.stringify(openTabs));

    // Invia messaggio Broadcast agli altri tab (opzionale, puoi anche non farlo)
    const bc = new BroadcastChannel("editTabs");
    bc.postMessage(openTabs);
    bc.close();

    // Apri modifica in nuova scheda
    const url = `${window.location.origin}${window.location.pathname}#${basePath}/${id}?parent_id=${record.parent_id}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Button
      component={Link}
      to={{
        pathname: linkToRecord(basePath, record.id),
        search: `parent_id=${record.parent_id}`,
      }}
      label={label}
      // onClick={stopPropagation}
      onClick={(e) => {
        stopPropagation(e);
        handleClick(e);
      }}
      {...(ModeOpenTabsOn
        ? { target: "_blank", rel: "noopener noreferrer" }
        : {})}
      {...rest}
    >
      {icon}
    </Button>
  );
};

EditButton.propTypes = {
  basePath: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object,
  label: PropTypes.string,
  record: PropTypes.object,
  icon: PropTypes.element,
};

const enhance = shouldUpdate(
  (props, nextProps) =>
    props.translate !== nextProps.translate ||
    (props.record &&
      nextProps.record &&
      props.record.id !== nextProps.record.id) ||
    props.basePath !== nextProps.basePath ||
    (props.record == null && nextProps.record != null)
);

export default withTranslate(enhance(EditButton));
